
import { Button, IconButton } from '@mui/material';
import './climbers.css';
import climbers1 from "../../../../../assets/climbers/climbers.jpeg";
import climbers2 from "../../../../../assets/climbers/climbers1.jpeg";
import climbers3 from "../../../../../assets/climbers/climbers2.jpeg";
import climbers4 from "../../../../../assets/climbers/climbers3.jpeg";
import BackIcon from '../../../../../components/back/back';

const FicusFamilies = [
    { id: 1, name: "Hadera Helix", img: climbers1, url: "/flowers" },
    { id: 2, name: "Bougainvillea", img: climbers2, url: "/fruits" },
    { id: 3, name: "Westeria", img: climbers3, url: "/quercus" },
    { id: 4, name: "Jasmin", img: climbers4, url: "/palms" },

];



export default function ClimbersCategorieDesktop() {
    return (
        <div className="ficus-container">
            <BackIcon />
            <div className="title-overlay">
                <div className="title-with-flowers">
                    <span className="flower-icon">🌼</span>
                    <h1>Climbers Collection</h1>
                    <span className="flower-icon">🌼</span>
                </div>
            </div>
            <div className="plants-category-container grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8" style={{ marginTop: "5rem" }}>
                {FicusFamilies.map((ficus) => (
                    <div key={ficus.id} className=" ficus-shape-card bg-white p-6 rounded-xl shadow-lg transform transition-all hover:scale-105">
                        <img
                            src={ficus.img}
                            alt={ficus.name}
                            className="w-full h-60 object-cover rounded-lg mb-4"
                        />
                        <p className="plant-name">{ficus.name}</p>
                    </div>
                ))}
            </div>
        </div>
    );
}
